import FilesService from "../services/FilesService";
import { removeEmptyKeys } from "./common";
import { documentTypes } from "@const/consentForms";
import { normalize, schema } from "normalizr";

export const createConsentFormModel = ({
  formName,
  documentType,
  firstPageFileId,
  secondPageFileId,
  selfieFileId,
  signedConsentFormFileId,
}) => {
  const model = {
    formName,
    documentType: Object.values(documentTypes).find(
      ({ label }) => label === documentType,
    )?.value,
    selfieFileId,
  };
  const chunksFirstPageFileId = FilesService.createChunks(firstPageFileId);
  const chunksSecondPageFileId = secondPageFileId
    ? FilesService.createChunks(secondPageFileId)
    : undefined;
  const chunksSelfieFileId = FilesService.createChunks(selfieFileId);
  const chunksSignedConsentFormFileId = FilesService.createChunks(
    signedConsentFormFileId,
  );

  model.firstPageFileId = {
    file: firstPageFileId,
    chunks: chunksFirstPageFileId,
  };
  if (chunksSecondPageFileId) {
    model.secondPageFileId = {
      file: secondPageFileId,
      chunks: chunksSecondPageFileId,
    };
  }

  model.selfieFileId = {
    file: selfieFileId,
    chunks: chunksSelfieFileId,
  };
  model.signedConsentFormFileId = {
    file: signedConsentFormFileId,
    chunks: chunksSignedConsentFormFileId,
  };

  return removeEmptyKeys(model);
};

export const normalizeConsentFormsArray = (originalConsentForms) => {
  const subscriptionsSchema = new schema.Entity("consentForms");

  const subscriptions = new schema.Array(subscriptionsSchema);

  return normalize(originalConsentForms, subscriptions);
};
